// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "instagram_integration".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { tokenStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "instagram_integration" table (1:1 with a DB row, on the wire). */
export const instagramIntegrationAtomSchema = z.object({
    id: z.string(),
    organizationId: z.string(),
    connectedById: z.string().nullable(),
    encryptedCredentials: z.string().nullable(),
    tokenExpiresAt: z.string().datetime().nullable(),
    instagramUserId: z.string().nullable(),
    username: z.string().nullable(),
    name: z.string().nullable(),
    profilePictureUrl: z.string().nullable(),
    accountType: z.string().nullable(),
    isActive: z.boolean(),
    chatbotEnabled: z.boolean(),
    postingOnly: z.boolean(),
    tokenStatus: z.enum(tokenStatusValues),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
});
//# sourceMappingURL=instagramIntegration.js.map